/** O catálogo de agentes é paginado no servidor; a simulação começa pela primeira página. */
export const PRIMEIRA_PAGINA_DE_AGENTES = { page: 1, limit: 20, search: '' };
